import { range } from 'lodash';
import { PerfectSkeleton } from '../../../../components/Common/perfect-skeleton/perfect-skeleton.component';
import {
  Container,
  PageHeader,
  PageHeaderLeft,
  PageHeaderRight,
  PageBody,
  StatisticSideContainer,
  StatisticsCardsMainContainer,
  StatisticsCardsLabelContainer,
  StatisticsCardsContainer,
  RealizationMetricsContainer,
  AssistantContainer,
  PositionPerformanceFunnelContainer,
  ScrollContainer,
  UserPickersSection,
  UserPickerAvatars,
  VerticalDivider,
  StatisticCard,
  RealizationMetricCard,
  AssistantHeader,
  AssistantBody,
  FunnelContainer,
  FunnelHeader,
  FunnelBars,
} from './position-overview-skeleton.styled';

const PositionOverviewSkeleton = (): JSX.Element => {
  const renderStatisticCard = () => (
    <StatisticCard>
      <PerfectSkeleton width={ 24 } height={ 24 } variant="circular" />
      <PerfectSkeleton width={ 80 } height={ 14 } variant="rectangular" />
      <PerfectSkeleton width={ 60 } height={ 32 } variant="rectangular" />
      <PerfectSkeleton width={ 120 } height={ 12 } variant="rectangular" />
    </StatisticCard>
  );

  const renderRealizationMetricCard = () => (
    <RealizationMetricCard>
      <PerfectSkeleton width={ 14 } height={ 16 } variant="circular" />
      <PerfectSkeleton width={ 180 } height={ 14 } variant="rectangular" />
      <PerfectSkeleton width={ 265 } height={ 24 } variant="rectangular" />
      <PerfectSkeleton width={ 250 } height={ 12 } variant="rectangular" />
    </RealizationMetricCard>
  );

  return (
    <ScrollContainer>
      <Container>
        <PageHeader>
          <PageHeaderLeft>
            <PerfectSkeleton width={ 450 } height={ 40 } variant="rectangular" />
            <PerfectSkeleton width={ 350 } height={ 20 } variant="rectangular" />
          </PageHeaderLeft>
          
          <PageHeaderRight>
            <UserPickersSection>
              <UserPickerAvatars>
                {range(3).map((index) => (
                  <PerfectSkeleton key={ `user-picker-avatar-${index}` } width={ 40 } height={ 40 } variant="circular" />
                ))}
              </UserPickerAvatars>
            </UserPickersSection>
            
            <VerticalDivider>
              <PerfectSkeleton width={ 2 } height={ 40 } variant="rectangular" />
            </VerticalDivider>
            
            <PerfectSkeleton width={ 52 } height={ 52 } variant="rounded" />
          </PageHeaderRight>
        </PageHeader>

        <PageBody>
          <StatisticSideContainer>
            <StatisticsCardsMainContainer>
              <StatisticsCardsLabelContainer>
                <PerfectSkeleton width={ 17 } height={ 17 } variant="circular" />
                <PerfectSkeleton width={ 120 } height={ 14 } variant="rectangular" />
              </StatisticsCardsLabelContainer>
              <StatisticsCardsContainer>
                {range(3).map((index) => (
                  <div key={ `statistic-card-${index}` }>
                    {renderStatisticCard()}
                  </div>
                ))}
              </StatisticsCardsContainer>
            </StatisticsCardsMainContainer>

            <RealizationMetricsContainer>
              {range(2).map((index) => (
                <div key={ `realization-metric-card-${index}` }>
                  {renderRealizationMetricCard()}
                </div>
              ))}
            </RealizationMetricsContainer>
          </StatisticSideContainer>

          <AssistantContainer>
            <AssistantHeader>
              <PerfectSkeleton width={ 16 } height={ 16 } variant="circular" />
              <PerfectSkeleton width={ 200 } height={ 20 } variant="rectangular" />
            </AssistantHeader>
            <AssistantBody>
              <PerfectSkeleton width={ 112 } height={ 112 } variant="circular" />
              <PerfectSkeleton width={ 280 } height={ 24 } variant="rectangular" />
              <PerfectSkeleton width={ 320 } height={ 16 } variant="rectangular" />
              <PerfectSkeleton width={ 300 } height={ 16 } variant="rectangular" />
              <PerfectSkeleton width={ 150 } height={ 40 } variant="rounded" />
            </AssistantBody>
          </AssistantContainer>
        </PageBody>

        <PositionPerformanceFunnelContainer>
          <FunnelContainer>
            <FunnelHeader>
              <PerfectSkeleton width={ 100 } height={ 20 } variant="text" />
            </FunnelHeader>
            <FunnelBars>
              {range(4).map((index) => (
                <PerfectSkeleton key={ `funnel-bar-${index}` } width={ 300 } height={ 150 } variant="rounded" />
              ))}
            </FunnelBars>
          </FunnelContainer>
        </PositionPerformanceFunnelContainer>
      </Container>
    </ScrollContainer>
  );
};

export default PositionOverviewSkeleton;
